import { Box, Divider, Typography } from "@mui/material";
import { React } from "react";
import AppButton from "../../../../../base/AppButton.component";
import { CheckCircle } from "@mui/icons-material";
import Theme from "../../../../../../utils/Theme";
import { useState } from "react";

const PromoteToManagerDialog = ({ manageUserHandler }) => {
  console.log("hjfvgthfvtbh", manageUserHandler);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const showSuccess = () => {
    setShowSuccessMessage(true);
  };
  return (
    <>
      <Divider sx={{ marginBottom: "24px" }} />
      <Typography
        variant="h6"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        Are you sure you want to Promote Employee?
      </Typography>
      <Divider sx={{ marginBottom: "24px", marginTop: "24px" }} />
      <Box sx={{ display: "flex", justifyContent: "center", gap: "12px" }}>
        {showSuccessMessage ? (
          <>
            <CheckCircle color={"primary"} />
            <span
              style={{
                color: Theme.palette.primary.main,
                marginLeft: "4px",
              }}
            >
              SUCCESS
            </span>{" "}
          </>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
            <AppButton
              sx={{ width: "200px", alignItems: "center" }}
              buttonText={"Cancel"}
              variant="outlined"
            />
            <AppButton
              sx={{ width: "200px", alignItems: "center" }}
              buttonText={"Confirm"}
              variant="contained"
              clickHandler={async () => {
                await manageUserHandler();
                showSuccess();
              }}
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default PromoteToManagerDialog;
